// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"View2_wrapper__i5HIa","topRow":"View2_topRow__15Knp","user":"View2_user__1Hk9F","mainUser":"View2_mainUser__2NSAK","bottomRow":"View2_bottomRow__2S9e-"};